import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CommonModalLayout from '../Layouts/CommonModalLayout';
import { buttonStyles, inputStyles, authModalStyles } from '../../styles/commonStyles';
import ErrorMessage from '../Common/ErrorMessage';
import RegisterModal from './RegisterModal';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';

const LoginModal = ({ isOpen, onClose, onAuthSuccess, isAuthPage = false }) => {
    const { t } = useTranslation();
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showRegister, setShowRegister] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { login: handleLogin } = useAuth();

    // Автозаполнение только для localhost
    useEffect(() => {
        const hostname = window.location.hostname;
        if (isOpen && (hostname === 'localhost' || hostname === '127.0.0.1')) {
            setLogin('admin333');
            setPassword('admin333admin333');
        }
    }, [isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await handleLogin({
                login,
                password
            });
            toast.success(t('auth.loginSuccess'));
            
            // Вызываем onAuthSuccess если он передан
            if (onAuthSuccess) {
                onAuthSuccess();
            } else {
                onClose();
            }
        } catch (error) {
            console.error('Login error:', error);
            setError(t('auth.errors.loginFailed'));
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackToLogin = () => {
        setShowRegister(false);
    };

    if (showRegister) {
        return <RegisterModal isOpen={isOpen} onClose={onClose} onLoginClick={handleBackToLogin} isAuthPage={isAuthPage} />;
    }

    return (
        <CommonModalLayout 
            isOpen={isOpen} 
            onClose={onClose} 
            customStyles={authModalStyles}
            title={t('auth.loginTitle')}
            closeOnOverlayClick={!isAuthPage} // Блокируем закрытие по клику на оверлей на странице авторизации
            showCloseButton={!isAuthPage} // Скрываем кнопку закрытия на странице авторизации
            hideOverlay={isAuthPage} // Скрываем темный оверлей на странице авторизации
        >
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                <input
                    type="text"
                    value={login}
                    onChange={(e) => setLogin(e.target.value)}
                    placeholder={t('auth.loginPlaceholder')}
                    className={inputStyles}
                    required
                />
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder={t('auth.passwordPlaceholder')}
                    className={inputStyles}
                    required
                />
                {error && <ErrorMessage message={error} />}
                <button
                    type="submit"
                    className={buttonStyles}
                    disabled={isLoading}
                >
                    {isLoading ? t('UI.loading') : t('auth.loginButton')}
                </button>
            </form>
            <button
                onClick={() => setShowRegister(true)}
                className="mt-4 text-sm text-blue-500 dark:text-blue-400 hover:underline"
            >
                {t('auth.registerLink')}
            </button>
        </CommonModalLayout>
    );
};

export default LoginModal; 